import { useEffect, useState } from 'react'
import { Button, Col, Collapse, Form, Row, Tabs, Tag } from 'antd';
import moment from "moment";

import { recordError } from "../../../utils/logService";

import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { ExceptionOutlined, FileDoneOutlined, FileSearchOutlined, FileTextOutlined, FileUnknownOutlined, MinusOutlined, PlusOutlined } from '@ant-design/icons';

import service from '../../../services/citizenScienceService';

import ProjectLead from './ProjectLead';
import ProjectDetails from './ProjectDetails';
import Organisations from './Organisations';
import ParticipantsRoles from './ParticipantsRoles';
import TargetBeneficiaries from './TargetBeneficiaries';
import Feedbacknotes from './Feedbacknotes';

import {
  Messages,
  Notify,
  openNotification,
  util
} from '@seims/shared';
const { Panel } = Collapse;

export default function ViewProjectDetails() {

    const [currentStatus, setCurrentStatus] = useState("");
    const [statusColour, setStatusColour] = useState("");
    const [statusIcon, setStatusIcon] = useState();
    const [projectLeadInfor, setProjectLeadInfor] = useState({});
    const [details, setDetails] = useState({});
    const [organisations, setOrganisations] = useState({});
    const [roles, setRoles] = useState({});
    const [targetBeneficiaries, setTargetBeneficiaries] = useState({});

    const [projectType, setProjectType] = useState("V");
    const [feedbackNotes, setFeedbackNotes] = useState({});
    const [assignVisible, setAssignVisible] = useState(false);

    useEffect(() => {
        prePopulate();
    }, []);

    useEffect(() => {
        setProjectType(type);
        statusColourSwitch(currentStatus);
    }, [currentStatus, projectType, assignVisible]);

    const { key, type } = useParams();
    const location = useLocation();
    let navigate = useNavigate();

    const formName = "ViewProjectDetailsForm";
    const [form] = Form.useForm();
    const formItemLayout = {
        labelCol: {
            span: 8,
        },
        wrapperCol: {
            span: 16,
        },
    };

    const prePopulate = async () => {

        try {
            if (key) {

                const id = key.substring(key.indexOf("x") + 1, key.length);
                if (!location?.state) {
                    openNotification(
                    "Projects",
                    "System is redirecting to project list",
                    Notify.WARNING
                    );
                    navigate("/project-management", { replace: true });
        
                    return;
                }

                const projectId = key.substring(key.indexOf("x") + 1, key.length);

                const response = await service.getProjectDetails(projectId);

                if (!location.state) {
                    openNotification(
                        "Project",
                        "System is redirecting to project list",
                        Notify.INFO
                    );
                    navigate("/project-management", { replace: true });

                    return;
                }

                if (response && response.status === 200) {
                    const { data } = response;

                    const projectLeadInfor = {
                        title: data.projectLead.title,
                        firstName: data.projectLead.firstName,
                        lastname: data.projectLead.lastname,
                        contactNumber: data.projectLead.contactNumber,
                        email: data.projectLead.email,
                    };
                    const projectDetails = {
                        name: data.name,
                        description: data.description,
                        scienceField: data.scienceField,
                        scienceDomains: data.scienceDomains,
                        researchMethodologies: data.researchMethodologies,
                        initiallyCitizenScience: data.initiallyCitizenScience,
                        objectives: data.objectives,
                        otherObjectives: data.otherObjectives,
                        dissemination: data.dissemination,
                        otherDissemination: data.otherDissemination,
                        startDate: data.startDate,
                        endDate: data.endDate,
                        locations: data.locations,
                        scienceShopInitiative: data.scienceShopInitiative
                    };
                    const participantsRoles = {
                        rolesDuringProject: data.rolesDuringProject,
                        rolesPostProject: data.rolesPostProject,
                        rolesPreProject: data.rolesPreProject,
                        contributionRecognition: data.contributionRecognition

                    }
                    const targetBeneficiaries = {
                        beneficiaries: data.beneficiaries.flatMap((b) =>
                            b.impact?.map((c) => c.key )
                        )
                    }
                    setCurrentStatus(data.status)
                    setProjectLeadInfor(projectLeadInfor);
                    setDetails(projectDetails);
                    setOrganisations(data.organisations);
                    setRoles(participantsRoles);
                    setTargetBeneficiaries(targetBeneficiaries)
                    setFeedbackNotes(data.feedbackNotes);

                }
            }
        } catch (error) {

        };
    };
    const statusColourSwitch = (status) => {
        switch (status?.trim()) {
            case "Submitted":
                setStatusColour("status-submitted");
                setStatusIcon(<FileTextOutlined />);
                setProjectType("V");
                setAssignVisible(false);
                break;
            case "In Review":
                setStatusColour("status-review");
                setStatusIcon(<FileSearchOutlined />);
                setProjectType("R");
                setAssignVisible(true);
                break;
            case "Approved":
                setStatusColour("status-approved");
                setStatusIcon(<FileDoneOutlined />);
                setProjectType("A");
                setAssignVisible(true);
                break;
            case "Rejected":
                setStatusColour("status-rejected");
                setStatusIcon(<ExceptionOutlined />);
                setProjectType("A");
                setAssignVisible(true);
                break;
            case "Closed":
                setStatusColour("status-cancelled");
                setStatusIcon(<FileUnknownOutlined />);
                setProjectType("A");
                setAssignVisible(true);
                break;
            default:
                setStatusColour("");
        }
    };
    const changeStatus = async () => {
        var msg;
        var action = "Project status";

        const id = key.substring(key.indexOf("x") + 1, key.length);
        const data = {
            projectId: id,
            action: "Review",
            notes: "Assigned ",
        };

        try {
            const response = await service.updateProjectStatus(data);

            if (response.status === 200 || response.status === 201) {
                msg = util.parseMessage(Messages.UPDATE_STATUS_ASSIGN, "Project");
                openNotification(action, msg, Notify.SUCCESS);
                setAssignVisible(true);
                setProjectType("R");
                setCurrentStatus("In Review");
                return;
            }

            msg = util.parseMessage(Messages.UPDATE_FAILURE_STATUS, "Project status");
            openNotification(action, msg, Notify.ERROR);
        } catch (error) {
            msg = util.parseMessage(Messages.UPDATE_FAILURE_STATUS, "Project status");
            openNotification(action, msg, Notify.ERROR);

            recordError(error);
        }
    };
    const handleStatusChange = (status) => {
        setCurrentStatus(status);
    };

    const returnHome = () => {
    const state = location?.state;
    
    if (state) {
      const { from } = state;
      navigate(from);

      const { currentPage, pageSize } =
        location.state?.data;
      navigate(from, {
        state: {
          currentPage: currentPage,
          pageSize: pageSize,
        },
      });
    } else {
      openNotification(
        "Candidates",
        "System is redirecting to candidate list",
        Notify.WARNING
      );
      navigate("/candidate", { replace: true });

      return;
    }
  };

  const handleCancel = () => {
    returnHome();
  };

  const onBackClick = () => {
    returnHome();
  };

    const Tab1 = () => {
        return (
            <>
                <Collapse
                    className="event-panel"
                    defaultActiveKey={["1"]}
                    expandIcon={({ isActive }) =>
                        isActive ? <MinusOutlined /> : <PlusOutlined />
                    }
                    expandIconPosition="end"
                >
                    <Panel header="Project Lead Info" key="projectLead">
                        <ProjectLead data={projectLeadInfor} />
                    </Panel>
                    <Panel header="Project Details" key="projectDetails">
                        <ProjectDetails data={details} />
                    </Panel>
                    <Panel header="Organisations" key="organisations">
                        <Organisations data={organisations} />
                    </Panel>
                    <Panel header="Citizen Scientist Roles" key="participantRoles">
                        <ParticipantsRoles data={roles} />
                    </Panel>
                    <Panel
                        header="Target Beneficiaries" key="targetParticipant"
                    >
                        <TargetBeneficiaries data={targetBeneficiaries} />
                    </Panel>
                </Collapse>
                <br />
                <Form {...formItemLayout} name={formName} form={form} layout="vertical">
                    {currentStatus === "In Review" && (
                        <Row>
                            <Col span={24} style={{ backgroundColor: "red" }}>
                                <Feedbacknotes
                                    status={currentStatus}
                                    onStatusUpdate={handleStatusChange}
                                />
                            </Col>
                        </Row>
                    )}
                </Form>
                <Row>
                    {projectType === "V" && assignVisible === false && (
                        <Col xs={24} className="right-align">
                            <Button
                                key="3a"
                                type="primary"
                                onClick={changeStatus}
                                style={{ marginRight: 10 }}
                            >
                                Assign to self
                            </Button>
                            &nbsp;
                                <Button type="default" onClick={onBackClick}>Back</Button>
                            {/* <Link key="1" to="/project-management">
                            </Link> */}
                        </Col>
                    )}
                    {projectType === "A" && (
                        <Col xs={24} className="right-align">
                                <Button type="default" onClick={onBackClick}>Back</Button>
                            {/* <Link key="1" to="/project-management">
                            </Link> */}
                        </Col>
                    )}
                </Row>
            </>
        );
    };
    const Tab2 = () => {
        return (
            <>
                <Form
                    {...formItemLayout}
                    name={formName}
                    form={form}
                    layout="vertical"
                    disabled
                >
                    <div>
                        {feedbackNotes?.map((feedback, index) => (
                            <Row
                                style={{ marginBottom: "10px", marginLeft: "20%" }}
                                key={index}
                            >
                                <Col span={8}>
                                    <span>
                                        <div
                                            dangerouslySetInnerHTML={{ __html: feedback.notes }}
                                        ></div>
                                    </span>
                                </Col>
                                <Col span={1}></Col>
                                <Col span={7}>
                                    {feedback.name},{" "}
                                    <Tag color="green">
                                        {moment(feedback.date).format("DD MMM YYYY, HH:mm")}
                                    </Tag>
                                </Col>
                            </Row>
                        ))}
                    </div>
                </Form>
                <Row>
                    <Col xs={24} className="right-align">
                        <Button type="default" onClick={onBackClick}>Back</Button>
                        {/* <Link key="1" to="/project-management">
                        </Link> */}
                    </Col>
                </Row>
            </>
        );
    };
    const tabList = [
        {
            key: "information",
            label: `Project information`,
            children: <Tab1 />,
        },
        {
            key: "feedback",
            label: `Feedback Notes`,
            children: <Tab2 />,
        },
    ];
    const onClickledTab = async (tab) => {
        if (tab === 2) {
            await prePopulate();
        }
    };

    return (
        <div className="content">
            <Row>
                <Col xs={24} sm={8} md={8}>
                    <h2>Project name : {details.name}</h2>
                </Col>
                <Col xs={24} sm={8} md={8} className="center-align">
                    <div className={statusColour + " status-label"}>
                        <div>
                            <span className="status-icon">{statusIcon}</span>&nbsp;{" "}
                            {currentStatus}
                        </div>
                    </div>
                </Col>
            </Row>
            <br />
            <Tabs
                className="event-information"
                defaultActiveKey="1"
                items={tabList}
                key="tab-key"
                onChange={onClickledTab}
            />
        </div>
    )
}
